"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyleOptions = exports.TextStyleControl = void 0;
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const Box_1 = __importDefault(require("@mui/material/Box"));
const utils_1 = require("../utils");
const textStyleOptions = [
    { label: 'Body 1', value: 'body1' },
    { label: 'Body 2', value: 'body2' },
    { label: 'Heading 1', value: 'h1' },
    { label: 'Heading 2', value: 'h2' },
    { label: 'Heading 3', value: 'h3' },
    { label: 'Heading 4', value: 'h4' },
    { label: 'Heading 5', value: 'h5' },
    { label: 'Heading 6', value: 'h6' },
    { label: 'Subtitle 1', value: 'subtitle1' },
    { label: 'Subtitle 2', value: 'subtitle2' },
];
exports.textStyleOptions = textStyleOptions;
const TextStyleControl = ({ defaultValue, disabled, editor }) => {
    const [style, setStyle] = (0, react_1.useState)(defaultValue ?? textStyleOptions[0]);
    const handleChange = (selected) => {
        (0, utils_1.chainFocus)(editor, (chain) => chain.setNode('paragraph', { variant: selected.value }));
        setStyle(selected);
    };
    return (react_1.default.createElement(Box_1.default, { sx: { margin: '0 0.5rem', minWidth: '200px' } },
        react_1.default.createElement(__1.Select, { "data-testid": "rich-text-style-selector", disabled: disabled, disableClearable: true, onChange: handleChange, options: textStyleOptions, size: "small", textFieldProps: { label: 'Text Style', inputProps: { tabIndex: -1 } }, value: style })));
};
exports.TextStyleControl = TextStyleControl;
exports.default = TextStyleControl;
